import Indicator, { IndicatorType } from '../types/Indicator'

const CommodityChannelIndex: Indicator = {
  type: IndicatorType.OVERLAY,
  value: 'commodityChannelIndex',
  label: 'Commodity Channel Index',
  nickname: 'CCI',
  fields: ['commodityChannelIndex'],
  params: {
    period: 20,
  },
}

export default CommodityChannelIndex
